import React, { useState } from "react";
import { Grid, withStyles } from "@material-ui/core";
import RMAXSlider from "../../../../../common/Slider";

const styles = (theme) => ({
  title: {
    fontSize: theme.textFontSize,
    fontWeight: "bold",
    marginTop: 12,
    textTransform: "uppercase",
  },
});

const BUFFER_CONFIG = {
  min: 0,
  max: 720,
  step: 30,
};

const AppointmentBuffer = ({
  onChange,
  appointmentBufferStart,
  appointmentBufferEnd,
  classes,
}) => {
  const [bufferStart, setBufferStart] = useState(appointmentBufferStart);
  const [bufferEnd, setBufferEnd] = useState(appointmentBufferEnd);
  const onStartChange = (event, value) => {
    setBufferStart(value);
  };

  const onEndChange = (event, value) => {
    setBufferEnd(value);
  };

  const onBufferDragEnd = () => {
    onChange({
      appointmentBufferStart: bufferStart,
      appointmentBufferEnd,
      appointmentBufferEnd: bufferEnd,
    });
  };
  return (
    <Grid container>
      <Grid className={classes.title} item xs={12}>
        <span>Appointment Buffer</span>
      </Grid>
      <RMAXSlider
        title={"Arrive Early (mins)"}
        min={BUFFER_CONFIG.min}
        max={BUFFER_CONFIG.max}
        step={BUFFER_CONFIG.step}
        value={bufferStart}
        onChange={onStartChange}
        onDragEnd={onBufferDragEnd}
      />

      <RMAXSlider
        title={"Arrive Late (mins)"}
        min={BUFFER_CONFIG.min}
        max={BUFFER_CONFIG.max}
        step={BUFFER_CONFIG.step}
        value={bufferEnd}
        onChange={onEndChange}
        onDragEnd={onBufferDragEnd}
      />
    </Grid>
  );
};
export default withStyles(styles)(AppointmentBuffer);
